export default {
    openOverlayPage(context, payload) {
        context.commit('addOverlayPage', payload);
    },
    nextOverlayPage(context) {
        context.commit('nextOverlayPage');
    },
    previousOverlayPage(context) {
        context.commit('previousOverlayPage');
    },
    closeOverlay(context) {
        context.commit('closeOverlay');
    },

};